import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Configure HMR behavior to reduce warnings
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_HMR_FIX) {
  // Override console.warn to filter out HMR dispose warnings
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const message = args.join(' ');
    // Filter out common HMR dispose warnings
    if (message.includes('unexpected require') &&
        (message.includes('react-hook-form') ||
         message.includes('react-dropzone') ||
         message.includes('lucide-react'))) {
      return; // Suppress these specific warnings
    }
    originalWarn.apply(console, args);
  };
}

// Performance instrumentation for startup
// const appStart = performance.now();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hot Module Replacement (HMR) - only in development
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', () => {
    try {
      const NextApp = require('./App').default;
      root.render(
        <React.StrictMode>
          <NextApp />
        </React.StrictMode>
      );
    } catch (error) {
      // Ignore HMR errors for disposed modules
      console.warn('HMR update skipped:', error.message);
    }
  });
}

// Measure first render frame
requestAnimationFrame(() => {
  // Performance measurement - can be used for monitoring if needed
  // const firstFrame = performance.now() - appStart;
});

// Web vitals can be logged to analytics service in production if needed
// reportWebVitals(console.log);
